import styled from "styled-components";
import VideoUploadCard from "./components/video-upload";
import { IVideoDetails, VideoDetailsKeys } from "types/videoData";
import VideoPreviewCard from "./components/video-preview";
import ThumbnailImage from "./components/thumnailImage";
import TrackArtists from "./components/track-artists";
import SongWriters from "./components/songWriters";
import AdditionalCredit from "./components/additionalCredits";
import Lyrics from "./components/lyrics";
import CheckList from "./components/checkList";

interface IProps {
  videoDetails: IVideoDetails | undefined;
  onChange: (key: VideoDetailsKeys, value: any) => void;
  checkList: boolean;
  setCheckList: (val: boolean) => void;
}
const StepTwo = ({
  videoDetails,
  onChange,
  checkList,
  setCheckList
}: IProps) => {
  return (
    <Container>
      <VideoUploadCard
        file={videoDetails?.file}
        onChangeFile={(file) => onChange("file", file)}
      />
      <VideoPreviewCard file={videoDetails?.file} />
      <ThumbnailImage
        videoFile={videoDetails?.file}
        setFile={(file) => onChange("thumbnail", file)}
        imageFile={videoDetails?.thumbnail}
      />
      <TrackArtists
        trackArtists={videoDetails?.trackArtists}
        onChange={(key, value) => {
          onChange(key, value);
        }}
      />
      <SongWriters
        songWriters={videoDetails?.songWriters || []}
        onChange={(key, val) => onChange(key, val)}
      />
      <AdditionalCredit
        additionalCredits={videoDetails?.additionalCredits || []}
        onChange={(credits) => {
          onChange("additionalCredits", credits);
        }}
      />
      <Lyrics
        lyricType={videoDetails?.lyricType || ""}
        setLyricType={(value) => onChange("lyricType", value)}
      />
      <CheckList
        allChecked={checkList}
        setCheckList={(val) => setCheckList(val)}
      />
    </Container>
  );
};

export default StepTwo;

const Container = styled.div`
  width: 100%;
  position: relative;
`;
